import { cn } from '@/lib/utils';

/**
 * Флаг страны картинкой.
 *
 * Эмодзи-флагов нет в системном шрифте Windows: там браузер рисует вместо флага
 * две буквы («DE», «NL»), и список стран превращается в ряд непонятных кодов.
 * Поэтому код страны считает бэк (`country_code`), а здесь по нему берётся SVG из
 * `flag-icons` (MIT). Файлы лежат в нашей сборке, с внешних адресов ничего не
 * грузится, и браузер скачивает только флаги, которые на странице есть.
 *
 * `?no-inline`: мелкие SVG Vite иначе вшил бы base64 прямо в JS, и в бандл уехали
 * бы все 270 флагов. Нет кода или файла (🌍, старый бэк) — показываем эмодзи как есть.
 */
const FILES = import.meta.glob<string>('/node_modules/flag-icons/flags/4x3/*.svg', {
  query: '?no-inline',
  import: 'default',
  eager: true,
});

const BY_CODE: Record<string, string> = Object.fromEntries(
  Object.entries(FILES).map(([path, url]) => [
    path.slice(path.lastIndexOf('/') + 1, -'.svg'.length),
    url,
  ]),
);

/** Размер задаёт `font-size` родителя: флаг высотой в строку, как был эмодзи. */
export function Flag({
  flag,
  code,
  className,
}: {
  flag: string;
  code?: string | null;
  className?: string;
}) {
  const src = code ? BY_CODE[code.toLowerCase()] : undefined;
  if (!src) return <>{flag}</>;
  return (
    <img
      src={src}
      alt=""
      aria-hidden
      draggable={false}
      loading="lazy"
      decoding="async"
      className={cn(
        'inline-block h-[0.9375em] w-[1.25em] rounded-[2px] object-cover align-[-0.12em]',
        className,
      )}
    />
  );
}
